/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "This is a reel of our most recent student and faculty work that was produced during 2018.  It features work from both graduate and undergraduates in teams and solo productions. Projects are developed in Photoshop, Z-Brush, Houdini, Maya, Substance Painter, Unity and GameMaker."), "\n", React.createElement(_components.p, null, "This video was shown at PAX South in Austin in 2019. This is a good representation of the projects and work that is done at LSU."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
